/* ZUVIE reservation path v1. No cookies, storage, extra requests or pixels.
   Source fields describe supplied URL tags, not verified Meta attribution. */
(function (w, d) {
  'use strict';
  if (w.ZVPath) return;
  var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content',
    'utm_term', 'utm_id', 'campaign_id', 'adset_id', 'ad_id', 'test_arm'];
  var pages = ['how-much-is-in-it', 'will-it-sting', 'the-serum-first'];

  function permission() {
    try {
      var p = w.Shopify && w.Shopify.customerPrivacy;
      if (!p || typeof p.analyticsProcessingAllowed !== 'function' ||
          typeof p.marketingAllowed !== 'function') return 'unavailable';
      return p.analyticsProcessingAllowed() === true && p.marketingAllowed() === true
        ? 'allowed' : 'not_allowed';
    } catch (_) { return 'unavailable'; }
  }

  function value(params, key) {
    var values = params.getAll(key);
    if (values.length !== 1) return '';
    var v = values[0];
    // Bounded machine tags only: reject emails, links, arbitrary text and macros.
    if (!v || v.length > 160 || !/^[A-Za-z0-9_.~-]+$/.test(v)) return '';
    if (key === 'campaign_id' || key === 'adset_id' || key === 'ad_id') {
      if (!/^\d{6,30}$/.test(v)) return '';
    }
    return v;
  }

  function read() {
    var state = permission();
    var result = { version: '1', status: state, origin_page: 'unknown', tags: {} };
    if (state !== 'allowed') return result;
    var url = new URL(w.location.href);
    var current = url.pathname.split('/').pop();
    var origin = pages.indexOf(current) !== -1 ? current : value(url.searchParams, 'zv_from');
    if (pages.indexOf(origin) !== -1) result.origin_page = origin;
    keys.forEach(function (key) {
      var v = value(url.searchParams, key);
      if (v) result.tags[key] = v;
    });
    result.status = Object.keys(result.tags).length ? 'tagged' : 'untagged';
    return result;
  }

  function fields(snapshot, prefix) {
    var out = {};
    out[prefix + 'version'] = snapshot.version;
    out[prefix + 'status'] = snapshot.status;
    out[prefix + 'origin_page'] = snapshot.origin_page;
    keys.forEach(function (key) { out[prefix + key] = snapshot.tags[key] || 'unknown'; });
    return out;
  }

  function decorate() {
    var links = d.querySelectorAll('a[data-zv-reserve-path]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      // Fixed same-origin destination; never use a URL supplied in a parameter.
      var url = new URL('/pages/reserve-or-join', w.location.origin);
      var source = read();
      if (source.status === 'tagged' || source.status === 'untagged') {
        Object.keys(source.tags).forEach(function (key) { url.searchParams.set(key, source.tags[key]); });
        if (source.origin_page !== 'unknown') url.searchParams.set('zv_from', source.origin_page);
      }
      link.href = url.pathname + url.search;
    }
  }

  w.ZVPath = {
    snapshot: read,
    eventFields: function (snapshot) { return fields(snapshot, 'zv_source_'); },
    profileFields: function (snapshot) { return fields(snapshot, 'zv_last_form_source_'); },
    validEmail: function (email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); },
    // Klaviyo deduplicates by profile + metric + unique_id. No identifier in URLs.
    eventId: function (mode) { return 'zuvie-first-launch-' + mode + '-v1'; },
    decorate: decorate
  };
  decorate();
  d.addEventListener('visitorConsentCollected', decorate);
  d.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('a[data-zv-reserve-path]')) decorate();
  }, true);
  if (w.Shopify && !w.Shopify.customerPrivacy && typeof w.Shopify.loadFeatures === 'function') {
    w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { decorate(); });
  }
})(window, document);

;
(function(){
 var terms={single:'One payment of $69. One bottle. No automatic refill.',pair:'One payment of $129. Two bottles. No automatic refill.',duo:'$129 for the first two bottles, then $112 every 2 calendar months until canceled. Reminder before each refill. Skip or cancel.'};
 document.querySelectorAll('input[name="offer"]').forEach(function(input){input.addEventListener('change',function(){document.getElementById('offer-terms').textContent=terms[input.value];});});
 document.querySelectorAll('a[href="#full-formula"]').forEach(function(a){a.addEventListener('click',function(){document.getElementById('full-formula').open=true;});});
})();
(function(){
 function keepSource(){if(!window.ZVPath)return;var s=ZVPath.snapshot();document.querySelectorAll('a[href]').forEach(function(a){if(a.hasAttribute('data-zv-reserve-path'))return;var u=new URL(a.href,location.href);if(u.origin!==location.origin||!/^\/pages\/(the-serum-first|how-much-is-in-it|will-it-sting|reserve-or-join)$/.test(u.pathname))return;u.search='';if(s.status==='tagged'||s.status==='untagged'){Object.keys(s.tags).forEach(function(k){u.searchParams.set(k,s.tags[k]);});if(s.origin_page!=='unknown')u.searchParams.set('zv_from',s.origin_page);}a.href=u.pathname+u.search+u.hash;});}
 keepSource();document.addEventListener('visitorConsentCollected',keepSource);document.addEventListener('click',keepSource,true);
})();

;

/* Market-aware price. Do not type a figure into this page again.
   First paint uses the map so there is no flicker, then the live product price
   overwrites it, so a price change in Shopify reaches this page on its own.
   The currency code beside the figure is painted from the same source.
   USD 6900 / GBP 4900 as at 2026-08-31 (STATUS.md, currency block). */
(function(){
  var SYMBOL = { USD:'$', GBP:'£', EUR:'€' };
  var FIRST_PAINT = { USD:6900, GBP:4900 };
  var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function fmt(cents){
    var v = cents / 100;
    return (SYMBOL[code] || code + ' ') + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function paint(cents){
    window.ZV_PRICE = fmt(cents);
    var n = document.querySelectorAll('.zv-price-auto');
    for (var i = 0; i < n.length; i++) n[i].textContent = window.ZV_PRICE;
    var c = document.querySelectorAll('.zv-cur-auto');
    for (var j = 0; j < c.length; j++) c[j].textContent = code;
  }
  if (FIRST_PAINT[code]) paint(FIRST_PAINT[code]);
  fetch('/products/the-pdrn-serum.js', { headers:{ 'Accept':'application/json' } })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(p){ if (p && typeof p.price === 'number') paint(p.price); })
    .catch(function(){});
})();
